import Component from '../abstracts/Component';
import ChatUtils from '../utils/ChatUtils';

/**
 Chat component
 */
export default class ChatComponent extends Component {

  constructor() {
    super();
  }

  bindEvents() {
    // contact us button
    let liveChatButton = document.querySelector('a[data-name=live-chat]');

    // button online
    this.$on('chatButtonEnabled', (e) => {
      if (liveChatButton != null) {
        liveChatButton.classList.remove('not-available');
        liveChatButton.classList.add('available');
      }
    });
    // button offline
    this.$on('chatButtonDisabled', (e) => {
      if (liveChatButton != null) {
        liveChatButton.classList.add('not-available');
        liveChatButton.classList.remove('available');
        liveChatButton.removeEventListener('click',function(){});
      }
    });
  }

  /////
  render() {
    this.log('rendering...');
    // some events
    this.bindEvents();
    // check if new chat is enabled
    let chatEnabled = (document.querySelector('#chatEnabled') != null) ? document.querySelector('#chatEnabled').value : false;
    // if is enabled let's launch it
    if (chatEnabled == 'true') {
      // script call
      let script = ChatUtils.getValue('urlEnvironmentSF')+'/embeddedservice/5.0/esw.min.js';
      // get script and initialize chat
      this.moduleLoader.loadExternalScript(script).then(() => {
        this.log('loading...');
        let options = {
           selectors: {
            startChatLink: 'a[data-name=live-chat]',
            chatLabelOnline: '#chatLabelOnlineNew',
          },
          subjects: {
            chatLabelSubject: '',
            chatLabelSubjectOptionOD: 'Orders and deliveries',
            chatLabelSubjectOptionRR: 'Refunds and Returns',
            chatLabelSubjectOptionPay: 'Payment, promotions and Gift Cards',
            chatLabelSubjectOptionFi: 'Collaboration',
            chatLabelSubjectOptionCS: 'Comments and Suggestions',
            chatLabelSubjectOptionPAv:'Product information and availability',
            chatLabelSubjectOptionSt: 'Stores',
            chatLabelSubjectOptionTA: 'Technical assistance'
          },
          ctaClasses: ['cta','cta-primary','cta-full-width'],
          // ctaTemplate: '<span class="bg-top"></span><span data-cta-text=":label:" class="text">:label:</span><span class="bg-bottom"></span>'
        }
        if (ChatUtils.getValue('liveChatShowFidelity') == 'true') {
           options.subjects = ChatUtils.addToObject(options.subjects,'chatLabelSubjectOptionFidelity','Fidelity Card',3);
        }
        if (ChatUtils.getValue('personalStylistSnapConfig')) {
          options.subjects = ChatUtils.addToObject(options.subjects,'chatLabelSubjectOptionPS','Personal Stylist',1);
        }

        // setup env
        ChatUtils.setEnvironment(options);
        // update cookie path
        ChatUtils.updatePath();
        // init the chat
        ChatUtils.initializeChat();
        // new chat modifier
        ChatUtils.runsNewChat();
      });
    }
  }
}
